import React from 'react'
import { Switch } from '@mui/material'
import { useDispatch } from 'react-redux'
import { createAccountancySoftware, updateAccountancySoftware } from '../state/actions'
import { AdministrationData } from './AccountancySoftwareList'

const Toggle = (props: AdministrationData & { disabled: boolean }) => {
  const [checked, setChecked] = React.useState(props.isactive)
  const [adminID, setAdminID] = React.useState(props.keyval)
  const dispatch = useDispatch()

  const putOrUpdate = async (flag: boolean, akey: string) => {
    if (adminID === '') {
      // insert data
      try {
        const response = await dispatch(
          createAccountancySoftware({
            IsActive: flag,
            Value: props.value,
            Name: props.name
          })
        )
        return response
      } catch (error) {
        throw error
      }
    } else {
      // update data
      try {
        const response = await dispatch(
          updateAccountancySoftware(akey, {
            IsActive: flag
          })
        )
        return response
      } catch (error) {
        throw error
      }
    }
  }

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const flag: boolean = event.target.checked // or use event.persist()
    const check = putOrUpdate(flag, adminID)
    check.then(d => {
      setAdminID(d.Data.UUID)
    })
    setChecked(event.target.checked)
  }
  return (
    <>
      <Switch
        disabled={props.disabled}
        color='primary'
        checked={checked}
        onChange={handleChange}
        inputProps={{ 'aria-label': 'controlled' }}
      />
      {props.name}
    </>
  )
}

export default Toggle
